const ANALYTICS_BASE_URL: string = './Analytics';
const AUTHORIZATION_BASE_URL: string = './Authorization';
const LOCAL_CONFIGURATION: string = 'Local_Values';
const PATIENT_EDUCATION_BASE_URL: string = './PatientEducation';
const PATIENT_EDUCATION_PDF_BASE_URL: string = './pdf';

const constants = {
    ANALYTICS_BASE_URL,
    AUTHORIZATION_BASE_URL,
    LOCAL_CONFIGURATION,
    PATIENT_EDUCATION_BASE_URL,
    PATIENT_EDUCATION_PDF_BASE_URL,
};

export default constants;
